module.exports = __webpack_public_path__ + "img/nonebook.5532e3c0.png";